<template>
  <div class="is-flex is-align-items-center py-1">
    <div>
      <router-link :to="`/posts/${serviceId}/${post.slug}`">{{ post.title }}</router-link>
    </div>
    <div class="pl-3 pt-1">
      <span
        v-if="isMastered"
        class="has-text-success mr-2"
      >
        <span class="icon">
          <i class="fas fa-check-circle"></i>
        </span>
        <!-- <span>{{ $t('term.isMastered') }}</span> -->
      </span>
      <span>
        <span
          v-if="counts.recent"
          class="mr-2"
        >
          {{ counts.recent }} / 3
        </span>
        <span> {{ counts.correct }} / {{ counts.total }}</span>
      </span>
      <button
        class="button is-small is-inline ml-3"
        @click="startDrillForPost"
      >
        <span class="icon">
          <i class="far fa-play-circle"></i>
        </span>
        <span>{{ $t('common.start') }}</span>
      </button>
    </div>
  </div>
</template>
<script>
import { User } from '@/api'

export default {
  name: 'DrillPostListItem',

  components: {},

  props: {
    post: {
      type: Object,
      required: true,
    },
    masteredPostIds: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      counts: {
        total: 0,
        correct: 0,
      },
    }
  },

  computed: {
    isMastered() {
      return this.masteredPostIds.includes(this.post.postId)
    },
  },

  async created() {
    await this.setAnswersCountByPostId()
  },

  methods: {
    async setAnswersCountByPostId() {
      this.$store.dispatch('setLoading', true)
      try {
        this.counts = await User.getPostAnswersCount(this.post.postId, null, this.userToken)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err) //!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
        return
      }
    },

    async startDrillForPost() {
      this.$store.dispatch('setLoading', true)
      let drill
      try {
        drill = await User.startDrillForPost(this.post.postId, this.userToken)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err) //!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
        return
      }

      this.$store.dispatch('prepareLearning', {
        drillId: drill.drillId,
        userAnswers: drill.userAnswers,
      })

      const nextAnswer = drill.userAnswers[0]
      this.$store.dispatch('setLearningCurrentAnswerId', nextAnswer.userAnswerId)
      window.open(`/posts/${nextAnswer.serviceId}/${nextAnswer.postSlug}`, '_blank')
      // this.$router.push(`/posts/${nextAnswer.serviceId}/${nextAnswer.postSlug}`)
    },
  },
}
</script>
